import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.css";
import { PathElem } from "./pathElem";
export const Path = ({ path, onNavigate = () => { }, }) => {
    return (_jsxs("div", Object.assign({ className: styles.pathWrapper }, { children: [_jsx(PathElem, { name: "/", onClick: () => onNavigate(null) }), path.map((item, idx) => {
                return (_jsxs("span", { children: [idx > 0 ? _jsx("p", { children: "/" }) : null, _jsx(PathElem, { name: item.title, onClick: () => onNavigate(item.id) })] }, item.id));
            })] })));
};
